import * as types from './types';
import _ from 'lodash';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { ImportExportItemsEnum } from 'Common/FieldEnum';

const INITIAL_STATE = {
  importItems: {
    Data: [],
    Errors: [],
  },
  importItemsLoading: false,
  columnMapping: [],
  fetchColumnsLoading: false,
  columns: [],
  fetchColumnsLoadingError: null,
  fetchExistingExportConfigLoading: false,
  existingExportConfig: [],
  fetchExistingExportConfigLoadingError: null,
  loadPreviousOptionsDropDown: [],
  submitting: false,
  submitted: false,
  submitError: null,
  importItemsDataLoading: false,
  importItemsData: null,
  importItemsDataLoadingError: null,
  deleteConfigLoading: false,
  deleteConfigLoadingError: null,
  deleteConfigData: null,
  fetchExistingImportConfigLoading: false,
  existingImportConfig: [],
  fetchExistingImportConfigLoadingError: null,
  loadPreviousImportOptionsDropDown: [],
  isFileEmpty: false,
  onlyOneItemPresent: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_IMPORT_ITEMS:
      return {
        ...state,
        importItems: action.payload,
        isFileEmpty:
          action.payload && action.payload.Data && !action.payload.Data.length,
        onlyOneItemPresent:
          action.payload &&
          action.payload.Data &&
          action.payload.Data.length === 1,
      };
    case types.CLEAR_IMPORT_ITEMS_DATA:
      return {
        ...state,
        importItems: INITIAL_STATE.importItems,
      };
    case types.ADD_ITEM_COLUMN_MAPPING:
      return {
        ...state,
        columnMapping: action.payload,
      };
    case types.SET_IMPORT_ITEMS_LOADING:
      return {
        ...state,
        importItemsLoading: action.payload,
      };
    case types.FETCH_COLUMNS_LOADING:
      return {
        ...state,
        fetchColumnsLoading: action.payload,
      };
    case types.SET_COLUMNS:
      return {
        ...state,
        columns: action.payload,
      };
    case types.FETCH_COLUMNS_LOADING_ERROR:
      const fetchColumnsLoadingError = action.payload.response;
      if (
        _.has(fetchColumnsLoadingError, 'data.Errors') &&
        fetchColumnsLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          fetchColumnsLoadingError: fetchColumnsLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        fetchColumnsLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching column list. Please try again.',
        },
      };
    case types.FETCH_EXISTING_EXPORT_CONFIG_LOADING:
      return {
        ...state,
        fetchExistingExportConfigLoading: action.payload,
      };
    case types.SET_EXISTING_EXPORT_CONFIG:
      return {
        ...state,
        existingExportConfig: action.payload.Data,
        loadPreviousOptionsDropDown: _.map(action.payload.Data, item => {
          return {
            key: item[ImportExportItemsEnum.Id],
            value: item[ImportExportItemsEnum.Id],
            text: item[ImportExportItemsEnum.Name],
          };
        }),
      };
    case types.FETCH_EXISTING_EXPORT_CONFIG_LOADING_ERROR:
      const fetchExistingExportConfigLoadingError = action.payload.response;
      if (
        _.has(fetchExistingExportConfigLoadingError, 'data.Errors') &&
        fetchExistingExportConfigLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          fetchExistingExportConfigLoadingError:
            fetchExistingExportConfigLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        fetchExistingExportConfigLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching existing export config list. Please try again.',
        },
      };
    case types.SAVE_LOADING:
      return {
        ...state,
        submitting: action.payload,
      };
    case types.SAVE_SUCCESS:
      return {
        ...state,
        submitted: true,
      };
    case types.SAVE_LOADING_ERROR:
      const submitResponse = action.payload.response;
      if (
        _.has(submitResponse, 'data.Errors') &&
        submitResponse.data.Errors.length
      ) {
        return {
          ...state,
          submitError: submitResponse.data.Errors,
        };
      }
      return {
        ...state,
        submitError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while saving items. Please try again.',
        },
      };
    case types.CLEAR_ERROR_SUCCESS:
      return {
        ...state,
        submitted: false,
        submitError: null,
        fetchColumnsLoadingError: null,
        fetchExistingExportConfigLoadingError: null,
        importItemsDataLoadingError: null,
        deleteConfigLoadingError: null,
        importItemsData: null,
        isFileEmpty: false,
        onlyOneItemPresent: false,
        deleteConfigData: null,
      };
    case types.SET_IMPORT_ITEMS_DATA_LOADING:
      return {
        ...state,
        importItemsDataLoading: action.payload,
      };
    case types.SET_IMPORT_ITEMS_DATA:
      return {
        ...state,
        importItemsData: action.payload,
      };
    case types.SET_IMPORT_ITEMS_DATA_LOADING_ERROR:
      const importItemsDataLoadingError = action.payload.response;
      if (
        _.has(importItemsDataLoadingError, 'data.Errors') &&
        importItemsDataLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          importItemsDataLoadingError: importItemsDataLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        importItemsDataLoadingError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while importing items. Please try again.',
        },
      };
    case types.DELETE_IMPORT_EXPORT_CONFIG_LOADING:
      return {
        ...state,
        deleteConfigLoading: action.payload,
      };
    case types.DELETE_IMPORT_EXPORT_CONFIG:
      return {
        ...state,
        deleteConfigData: action.payload,
      };
    case types.DELETE_IMPORT_EXPORT_CONFIG_LOADING_ERROR:
      const deleteConfigLoadingError = action.payload.response;
      if (
        _.has(deleteConfigLoadingError, 'data.Errors') &&
        deleteConfigLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          deleteConfigLoadingError: deleteConfigLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        deleteConfigLoadingError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while deleting items. Please try again.',
        },
      };
    case types.FETCH_EXISTING_IMPORT_CONFIG_LOADING:
      return {
        ...state,
        fetchExistingImportConfigLoading: action.payload,
      };
    case types.SET_EXISTING_IMPORT_CONFIG:
      return {
        ...state,
        existingImportConfig: action.payload.Data,
        loadPreviousImportOptionsDropDown: _.map(action.payload.Data, item => {
          return {
            key: item[ImportExportItemsEnum.Id],
            value: item[ImportExportItemsEnum.Id],
            text: item[ImportExportItemsEnum.Name],
          };
        }),
      };
    case types.FETCH_EXISTING_IMPORT_CONFIG_LOADING_ERROR:
      const fetchExistingImportConfigLoadingError = action.payload.response;
      if (
        _.has(fetchExistingImportConfigLoadingError, 'data.Errors') &&
        fetchExistingImportConfigLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          fetchExistingImportConfigLoadingError:
            fetchExistingImportConfigLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        fetchExistingImportConfigLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching existing export config list. Please try again.',
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/importExport/reducer.js